<div class="container-portfolio">
  <div class="container-title" [ngClass]="{'container-title-aggregation': portfolio.aggregati.length > 1 }">
    <div class="title-subtitle">
      <span class="title" [ngClass]="{'invalid': isSelectedValueInvalid}">{{title}}</span>
      <div class="subtitle-wrapper" *ngIf='portfolio.aggregati.length > 1'>
        <span class="subtitle" *ngFor='let aggregate of portfolio.aggregati; let i = index'>{{aggregate.name}}
          {{i < portfolio.aggregati.length - 1 ? '+&nbsp;' : ''}}</span>
      </div>
    </div>
    <div ngbDropdown class="dropdown" *ngIf='portfolio.aggregati.length > 1'>
      <app-action-button ngbDropdownAnchor [fab]="fab" id='dropdownMenuButton'></app-action-button>
      <div ngbDropdownMenu class="dropdown-menu aggregation" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" (click)='deleteAggregation(portfolio.id)'>
          <i class="ic-delete"></i>
          <span class="delete-btn">Delete Aggregation</span>
        </a>
      </div>
    </div>
    <div *ngIf='isSelectedValueInvalid' class="ic-info invalid"></div>
  </div>
  <div class="container-config">
    <ng-container *ngFor='let attribute of portfolio.attribute; let i = index'>
      <ng-container *ngIf='portfolio.pristine ? i === 0 : true'>
        <div class="config row">
          <div class="name-container col-6">
            <label class="name" [ngClass]="{'invalid': attribute.isInvalidField}">{{attribute?.name}}</label>
          </div>
          <div class="col-6">
            <ng-select
              [clearable]="false"
              class="custom select-check-value"
              bindLabel="value"
              bindValue="id"
              [ngModel]="attribute.isMultiSelectionAvailable ? attribute.chosen_values : attribute.chosen_values[0] " (ngModelChange)="attribute.isMultiSelectionAvailable ? attribute.chosen_values : attribute.chosen_values[0] = $event"
              [searchable]="false"
              [closeOnSelect]="!attribute.isMultiSelectionAvailable"
              placeholder='Select an option...'
              [multiple]='attribute.isMultiSelectionAvailable'
              [class.multiselect]='attribute.isMultiSelectionAvailable'
              [closeOnSelect]='!attribute.isMultiSelectionAvailable'
              [items]='attribute.value_lists'
              (change)='setChosenValue($event, attribute)'
              (close)='sendChosenValue(attribute)'
              (remove)='onClear(attribute)'
            >
            </ng-select>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf='isSelectedValueInvalid' class="invalid-message">
    <p>{{ invalidSelectedErrorMessage }}</p>
  </div>
</div>